import {
    $, addAction, doAction, INIT, GA_EVENT,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    $('body').on('click', '.sbi_item', () => {
        doAction(GA_EVENT, ['Connect', 'Exit', 'InstagramPost']);
    });
});
